import React, { useEffect } from "react";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import LogoImage from "../../assets/images/Logo-header.png";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Link } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse } from "@mui/material";
const drawerWidth = 240;


const drawerMenu = [
  {
    icon: <AccountBalanceIcon />,
    name: "Treatment Data",
    route: "/systemUsageReports",
  }
  // Commented out menu items
  // {
  //   icon: "AccountBalanceIcon",
  //   name: "Billing",
  //   route: "/billing_calculation",
  // },
  // {
  //   icon: "SummarizeIcon",
  //   name: "Billing Summary",
  //   route: "/billing_summary",
  // },
  // {
  //   icon: <InfoIcon />,
  //   name: "Info",
  //   route: "/dashboard",
  //   subMenu:[
  //     {
  //       icon: "Inbox",
  //       name: "Organizations",
  //       route: "/dashboard"
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Store/ Medical Office",
  //       route: "/stores",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Org Employee",
  //       route: "/org_employee",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Patients",
  //       route: "/patient",
  //     }
  //   ]
  // },
  // {
  //   icon: <SupervisorAccountIcon />,
  //   name: "MM Admin",
  //   route: "/dashboard",
  //   subMenu:[
  //     {
  //       icon: "Inbox",
  //       name: "MM Employee",
  //       route: "/employee",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "MM Systems",
  //       route: "/mm_system",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "MM Devices",
  //       route: "/mm_device",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Component",
  //       route: "/component",
  //     }
  //   ]
  // },
  
  // {
  //   icon: <ReportIcon />,
  //   name: "Reports",
  //   route: "/dashboard",
  //   subMenu:[
  //     {
  //       icon: "Inbox",
  //       name: "Organization",
  //       route: "/reports/organisation",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Store Organization",
  //       route: "/reports/store_organisation",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Store",
  //       route: "/reports/store",
  //     },{
  //       icon: "Inbox",
  //       name: "System",
  //       route: "/reports/system_report",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Device",
  //       route: "/reports/device_report",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Organisation Billing",
  //       route: "/reports/organisation_billing_report",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Store System",
  //       route: "/reports/store_organisation_system",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Store Doctor",
  //       route: "/reports/store_doctor_report"
  //     }
  //   ]
  // },
  // {
  //   icon: <SupervisorAccountIcon />,
  //   name: "Inventory",
  //   route: "/dashboard",
  //   subMenu:[
  //     {
  //       icon: "Inbox",
  //       name: "System",
  //       route: "/system",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Abarla Part",
  //       route: "/invAbarlaPartRef",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Lot Line",
  //       route: "/invLotLineDesc",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Category",
  //       route: "/invCategoryType",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Assembly Category",
  //       route: "/invAssemblyCategoryType",
  //     },
  //     {
  //       icon: "Inbox",
  //       name: "Part Category",
  //       route: "/invPartCategoryType",
  //     }
  //   ]
  // },
  // {
  //   icon: <HelpIcon />,
  //   name: "Help",
  //   route: "/dashboard",
  //   subMenu:[
  //     {
  //       icon: "AdbIcon",
  //       name: "Debugging",
  //       route: "/tabsToServer",
  //     },
  //     {
  //       icon: "InputIcon",
  //       name: "Logs",
  //       route: "/employeeLogs"
  //     },
  //     {
  //       icon: "ContactSupportIcon",
  //       name: "Contact Info",
  //       route: "/contact"
  //     },
  //   ]
  // }
];




const LeftSidebar = () => {
  const [openCollapse, setOpenCollapse] = React.useState(["Billing"]);
  // const [, setOpenCollapse] = React.useState([]);

  useEffect(()=>{
    getSubmenuHandle()
  },[])

 
 
  const onSubMenuCLink = (val) =>{
    const index = openCollapse.findIndex(item=>item===val);
    if(index > -1){
      setOpenCollapse((current) =>
       current.filter((item) => item !== val)
      )
      const data = (current) => current.filter((item) => item !== val)
      localStorage.setItem('@submenu',  JSON.stringify(data));
    }else{
      setOpenCollapse(prevSate=>[...prevSate,val])
      localStorage.setItem('@submenu',  JSON.stringify([...openCollapse,val]));
    }
    
  }

  const getSubmenuHandle = () =>{
    let data = localStorage.getItem('@submenu');
    if(data !== null && data !== "undefined"){
      const parsedData = JSON.parse(data);
      if (!parsedData.includes("Billing")) {
        parsedData.push("Billing");
        localStorage.setItem('@submenu', JSON.stringify(parsedData));
      }
      setOpenCollapse(parsedData);
    } else {
      // Initialize localStorage with empty array
      localStorage.setItem('@submenu', JSON.stringify([]));
      setOpenCollapse([]);
    }
  }

  const checkCollapse = val =>openCollapse.some(item=>item===val);

  const drawer = (
    <div>
      <Toolbar>
        <Link to={"/"}>
          <img src={LogoImage} alt="Logo" />
        </Link>
      </Toolbar>
      <Divider />
      <List>
        {drawerMenu.map((item, index) => (
          item.subMenu && item.subMenu.length > 0 
          ? 
          <React.Fragment key={`menu-item-${item.name}-${index}`}>
            <ListItem disablePadding>
            <ListItemButton onClick={()=>onSubMenuCLink(item.name)}>
              <ListItemIcon>
              {/* <HtmlIcon Tag={item.icon}/> */}
              {/* <svg data-testid={item.icon}></svg> */}

              {/* {HtmlIcon(item.icon)} */}
              {item.icon}
                {/* {index % 2 === 0 ? <InfoIcon /> : <MailIcon />} */}
              </ListItemIcon>
              <ListItemText primary={item.name} />
                {checkCollapse(item.name) === true ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={checkCollapse(item.name)} timeout="auto" unmountOnExit>
          <List className={"submenu"} component="div" disablePadding>
          {
            item.subMenu.map((sub, i) =>(
              <ListItem key={`submenu-item-${sub.name}-${index}-${i}`} disablePadding>
              <ListItemButton component={Link} to={sub.route}>
                <ListItemIcon className={"submenu-icon"}>
                  <InboxIcon />
                </ListItemIcon>
                <ListItemText
                  className={"submenu-text"}
                  primary={sub.name}
                />
              </ListItemButton>
            </ListItem>
            ))
          }
          </List>
        </Collapse>
          </React.Fragment>
          :
          <ListItem key={`menu-item-${item.name}-${index}`} disablePadding>
            <ListItemButton component={Link} to={item.route}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
       
       
      </List>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        // container={container}
        variant="temporary"
        // open={mobileOpen}
        // onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default LeftSidebar;
